import type { ApiClient } from './client.js';

export type WeatherKindDto =
  | 'sunny'
  | 'partly-sunny'
  | 'cloudy'
  | 'rainy'
  | 'thunder'
  | 'snowy'
  | 'windy'
  | 'foggy';

export interface WeatherStateDto {
  classroomId: string;
  selectedKind: string | null;
  temperature: number | null;
  localTemperature: number | null;
  localFetchedAt: string | null;
  /** ISO YYYY-MM-DD of the last manual pick (local date), or null. */
  selectedDate: string | null;
  updatedAt: string;
}

export interface WeatherHistoryEntryDto {
  date: string;
  kind: string | null;
  temperature: number | null;
}

export interface UpdateWeatherTodayBody {
  selectedKind?: string | null;
  temperature?: number | null;
  /** Viewer's local date (YYYY-MM-DD) so the pick lands on the kiosk's day. */
  date?: string;
}

export interface WeatherApi {
  getState(classroomId: string): Promise<WeatherStateDto>;
  setToday(classroomId: string, body: UpdateWeatherTodayBody): Promise<WeatherStateDto>;
  getHistory(classroomId: string, month: string): Promise<WeatherHistoryEntryDto[]>;
}

export function createWeatherApi(client: ApiClient): WeatherApi {
  return {
    async getState(classroomId) {
      const res = await client.get<{ weather: WeatherStateDto }>(
        `/api/classrooms/${classroomId}/weather`,
      );
      return res.weather;
    },
    async setToday(classroomId, body) {
      const res = await client.put<{ weather: WeatherStateDto }>(
        `/api/classrooms/${classroomId}/weather/today`,
        body,
      );
      return res.weather;
    },
    async getHistory(classroomId, month) {
      const res = await client.get<{ history: WeatherHistoryEntryDto[] }>(
        `/api/classrooms/${classroomId}/weather/history?month=${month}`,
      );
      return res.history;
    },
  };
}
